import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, showWelcomeToast } from "@/lib/api";
import { useAuth } from "@/App";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const session_id = m ? decodeURIComponent(m[1]) : null;
    if (!session_id) {
      navigate("/");
      return;
    }
    (async () => {
      try {
        const r = await api.post("/auth/session", { session_id });
        if (r.data.session_token) localStorage.setItem("session_token", r.data.session_token);
        const u = r.data.user;
        // Propagate user into global AuthContext so Navbar updates without a hard refresh.
        setUser(u);
        // Clear hash and go to profile setup if user missing role/username
        window.history.replaceState(null, "", "/");
        if (!u.role || !u.username) {
          navigate("/profile", { state: { user: u } });
        } else {
          // Welcome toast with survey CTA — only when landing on the forum
          // (skip if user still needs to complete profile to avoid double prompts).
          showWelcomeToast(u.username);
          navigate("/", { state: { user: u } });
        }
      } catch (e) {
        setError(e?.response?.data?.detail || "Authentication failed");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",background:"#F8F7F4"}}>
      <div style={{textAlign:"center"}}>
        <div className="logo" style={{fontSize:32,marginBottom:18}}>
          <strong>LANTEN</strong> <em>forum</em>
        </div>
        <p style={{color:"#6C6C70",fontSize:14}}>
          {error ? `Error: ${error}` : "Signing you in…"}
        </p>
      </div>
    </div>
  );
}
